<script>
import Aws from '@/services/Aws';
import Swal from "sweetalert2";


export default {
  components:{
  },
  props: ['launchTemplateData'],
  data() {
    return {
      csrf_token: localStorage.getItem('csrf_token'),
      submitted: false,
      showModal: false,
      tryingToEdit: false,
      showLoader:false,
      tableData:[],
      isBusy:false,
      totalRows:0,
      perPage:10,
      currentPage:1,
      pageOptions: [10, 25],
      filter: null,
      filterOn: [],
      sortBy: "AutoScalingGroupName",
      sortDesc: false,
      fields: [
        {
          key: "VersionNumber",
          label: "Version Number",
          sortable: false,
        },
        {
          key: "VersionDescription",
          label: "Version Description",
          sortable: false,
        },
        {
          key: "DefaultVersion",
          label: "Default",
          sortable: false,
          class: "text-center"
        },
        {
          key: "ImageId",
          label: "Image Id",
          sortable: false,
        },
        {
          key: "InstanceType",
          label: "Instance Type",
          sortable: false,
        },
        {
          key: "CreateTime",
          label: "Create Time",
          sortable: false,
        },
        "action",
      ]
    };
  },
  computed:{
    modalTitle(){
      return 'Launch Template ' + this.launchTemplateData.LaunchTemplateName + ' (' + this.launchTemplateData.LaunchTemplateId +')' + ' Versions'
    }
  },
  methods: {

    async getLaunchTemplateVersions(){
      try {
        this.isBusy = true;
        const response = await Aws.getLaunchTemplateVersions('LaunchTemplateId='+this.launchTemplateData.LaunchTemplateId);
        this.originalTableData = response.data.data;
        this.tableData = [...this.originalTableData];
        this.totalRows = this.tableData.length;
      } catch (error) {
        this.error = error.response.data.error ? error.response.data.error : "";
        this.tableData = [];
        this.totalRows = 0;
      } finally {
        this.showLoader = false;
        this.isBusy = false;
      }
    },

    removeLaunchTemplateVersion(templateData) {
      Swal.fire({
        title: "Remove Template Version " + templateData.VersionNumber + "?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Delete",
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          // Show deleting loader
          Swal.fire({
            title: 'Deleting...',
            html: 'Please wait while the launch template version is being removed.',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });

          setTimeout(async () => {
            try {
              const response = await Aws.removeLaunchTemplateVersion({
                LaunchTemplateId: templateData.LaunchTemplateId,
                VersionNumber: templateData.VersionNumber,
              });

              Swal.close();

              const res = response?.data?.data || false;
              const error = response?.data?.error || "Failed";

              if (res) {
                this.successmsg('Removed Template Version', 'Template Version is successfully removed');
                setTimeout(() => {
                  this.getLaunchTemplateVersions();
                }, 2000);
              } else {
                this.failedmsg('Fail!', error);
              }
            } catch (err) {
              Swal.close();
              const errorMsg = err.response?.data?.error || "";
              this.failedmsg('Fail!', errorMsg);
            }
          }, 100); // short delay ensures modal shows
        }
      });
    },

    refreshData() {
      this.$emit('onRefresh')
    },

    closeModal() {
      this.showModal = false
    },

    initialData(){

      this.totalRows=0
      this.perPage=10
      this.currentPage=1
      this.tableData=[]
      this.getLaunchTemplateVersions()

    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    isOlderThan3Months(version) {
      if (!version.CreateTime) return false;

      const created = new Date(version.CreateTime);
      const now = new Date();

      // Three months ago (approx 90 days)
      const threeMonthsAgo = new Date();
      threeMonthsAgo.setMonth(now.getMonth() - 3);

      return created < threeMonthsAgo;
    },

    setDefaultTemplate(launchTemplate) {
      const details = launchTemplate;

      if (!details) {
        Swal.fire({
          icon: "info",
          title: "No Details Found",
          text: "No information available for the latest version.",
        });
        return;
      }

      const html = `
        <div class="text-start">
            <p class="mt-3 mb-3"><strong>Name:</strong><br>${details.LaunchTemplateName}</p>
            <p class="mb-3"><strong>Version:</strong><br>${details.VersionNumber}</p>
            <p class="mb-3"><strong>Description:</strong><br>${details.VersionDescription || '-'}</p>
            <p class="mb-3"><strong>Created By:</strong><br>${details.CreatedBy}</p>
            <p class="mb-3"><strong>Created At:</strong><br>${details.CreateTime}</p>
            <p class="mb-3"><strong>Image ID:</strong><br>${details.LaunchTemplateData.ImageId}</p>
            <p class="mb-3"><strong>Instance Type:</strong><br>${details.LaunchTemplateData.InstanceType}</p>
            <p class="mb-3"><strong>Key Name:</strong><br>${details.LaunchTemplateData.KeyName}</p>
            <p class="mb-0"><strong>Security Groups:</strong><br>${details.LaunchTemplateData.SecurityGroupIds.join(', ')}</p>
        </div>
    `;

      Swal.fire({
        title: `New Launch Template v${details.VersionNumber}`,
        html: html,
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonText: "Make Default Template",
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        width: 600,
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: `Make ${details.VersionNumber} the Default Launch Template?`,
            icon: "warning",
            html: `
                    <p>Type <strong>"Confirm"</strong> to proceed:</p>
                    <input type="text" id="confirmInput" class="swal2-input" autocomplete="off">
                `,
            showCancelButton: true,
            confirmButtonText: "Confirm",
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            showLoaderOnConfirm: true,
            preConfirm: () => {
              const value = Swal.getPopup().querySelector("#confirmInput").value;
              if (value.toLowerCase() !== "confirm") {
                Swal.showValidationMessage('You must type "Confirm" to proceed');
                return false;
              }

              return Aws.makeDefaultLaunchTemplate({
                LaunchTemplateId: details.LaunchTemplateId,
                VersionNumber: details.VersionNumber,
              })
                .then((response) => {
                  return response;
                })
                .catch((error) => {
                  let errorMsg = error.response.data.error
                      ? error.response.data.error
                      : "";
                  this.failedmsg("Fail!", errorMsg);
                });
            },
          }).then((res) => {
            if (result.isConfirmed) {
              const response = result.value; // Axios response
              const error = response.error ? response.error : "Failed";

              if (response === true) {
                this.successmsg(
                    'Default Launch Template',
                    `Launch template ${details.VersionNumber} is now set as default.`
                );

                setTimeout(() => {
                  this.getLaunchTemplateVersions()
                  this.refreshData()
                }, 2000);
              } else {
                this.warningmsg("Fail!", error);
              }
            }
          });
        }
      });
    },

  }
};
</script>

<template>
  <b-modal ref="launchTemplateModal" @shown="initialData" v-model="showModal" id="view_launchTemplateVersionsModal" :title="modalTitle" size="xl" title-class="font-18" centered>
    <div class="table-responsive mb-0">
      <b-table
          :busy="isBusy"
          :items="tableData"
          :fields="fields"
          responsive="sm"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter="filter"
          :filter-included-fields="filterOn"
          show-empty
          empty-text="No Data Found"
          @filtered="onFiltered"
      >

        <template v-slot:cell(ImageId)="data">
            <span v-if="data.item.LaunchTemplateData.ImageId">
              {{ data.item.LaunchTemplateData.ImageId }}
            </span>
        </template>

        <template v-slot:cell(DefaultVersion)="data">
          <div :class="{'bg-success text-white':data.item.DefaultVersion == true}">
            {{data.item.DefaultVersion}}
          </div>
        </template>

        <template v-slot:cell(InstanceType)="data">
            <span v-if="data.item.LaunchTemplateData.InstanceType">
              {{ data.item.LaunchTemplateData.InstanceType }}
            </span>
        </template>

        <template v-slot:cell(action)="data">
          <ul class="list-inline mb-0 text">
            <li class="list-inline-item" v-if="isOlderThan3Months(data.item) && !data.item.DefaultVersion">
              <a href="#" class="text-danger" @click="removeLaunchTemplateVersion(data.item)" title="Remove Launch Template Version">
                <i class="uil uil-trash-alt font-size-18"></i>
              </a>
            </li>
            <li class="list-inline-item" v-if="!data.item.DefaultVersion">
              <a href="#" class="text-primary" @click="setDefaultTemplate(data.item)" title="Set Default Launch Template Version">
                <i class="uil uil-check-circle font-size-18"></i>
              </a>
            </li>

          </ul>
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>

      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
    </template>
  </b-modal>
</template>